module.exports = __webpack_public_path__ + "static/media/54799989_2519318078143368_4538865045492203520_o.a34d5cd9.jpg";